import { render, staticRenderFns } from "./CursadosAlum.vue?vue&type=template&id=85a88a8e&scoped=true&"
import script from "./CursadosAlum.vue?vue&type=script&lang=js&"
export * from "./CursadosAlum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a88a8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
